import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PaywallPdfPage = ({
  file,
  width,
  fallback = null,
}: {
  file: File;
  width: number;
  fallback?: React.ReactNode;
}) => (
  <Document
    file={file}
    loading={fallback}
    error={fallback}
    onPassword={() => {}}
  >
    <Page
      pageNumber={1}
      width={width}
      renderTextLayer={false}
      renderAnnotationLayer={false}
    />
  </Document>
);

export default PaywallPdfPage;
